import {fetch} from "utils/dataAccess";

/**
 * Request an asynchronous export of the attribute values of a tab: the API
 * responds 202 and emails the generated xlsx to the connected user.
 */
export default function exportAttributeValues(type, optionId = null) {
    const params = new URLSearchParams({type});

    if (optionId) {
        params.set('optionId', optionId);
    }

    return fetch(`/marketplace/attribute_values/export?${params.toString()}`, {method: 'GET'});
}
